module.exports = __webpack_public_path__ + "img/load.22cbc10c.jpg";